import { ModalController } from '@ionic/angular';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-modal',
  templateUrl: './help-modal.component.html',
  styleUrls: ['./help-modal.component.scss'],
})
export class HelpModalComponent implements OnInit {

  constructor(public modalController:ModalController) { }

  ngOnInit() {}

  closeButtonClick(){
    this.modalController.dismiss();
  }

}
